<template>
<svg viewBox="0 0 24 24" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-fill-ellipsis`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M4.33329 13.3333C5.25377 13.3333 5.99996 12.5871 5.99996 11.6667C5.99996 10.7462 5.25377 10 4.33329 10C3.41282 10 2.66663 10.7462 2.66663 11.6667C2.66663 12.5871 3.41282 13.3333 4.33329 13.3333ZM12 13.3333C12.9204 13.3333 13.6666 12.5871 13.6666 11.6667C13.6666 10.7462 12.9204 10 12 10C11.0795 10 10.3333 10.7462 10.3333 11.6667C10.3333 12.5871 11.0795 13.3333 12 13.3333ZM19.6666 13.3333C20.5871 13.3333 21.3333 12.5871 21.3333 11.6667C21.3333 10.7462 20.5871 10 19.6666 10C18.7462 10 18 10.7462 18 11.6667C18 12.5871 18.7462 13.3333 19.6666 13.3333Z"/></svg>
</template>
<script>

export default {
  name: 'IconFillEllipsis',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
